import React from "react";
import { ERCText } from "components/text";

const ExperienceCard = ({ img, headerText, description, onClick }) => {

    return (
        <div className="bg-[#F4F4F2] flex items-start gap-2 w-full rounded-[12px] p-6" onClick={onClick} style={{ cursor: "pointer"}}>
            {img}
            <div className="flex flex-col gap-4">
                <ERCText lHeight="32px" color="#00296B" size="24px" weight="700" >{headerText}</ERCText>
                <ERCText align="justify" color="#252525" size="14px" weight="400" lHeight="20px" >{description}</ERCText>
            </div>
        </div>
    )

}

export default ExperienceCard